import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';

import { WeekendsVisibilityPreferenceField } from '~libs.desktop.shared.appointments-timetable';

import { ScheduleOnlyVisibilityPreferenceField } from '../../../shared/preferences/ScheduleOnlyVisibilityPreferenceField/ScheduleOnlyVisibilityPreferenceField';
import { useWeekendsVisibilityPreference } from '../../SpecialistTimetable.hooks';
import { useScheduleOnlyVisibilityPreferenceState } from '../../../shared/preferences/preferences.storage';

import {
   SpecialistTimetablePreferencesFormBean,
   SpecialistTimetablePreferencesFormController,
} from './SpecialistTimetablePreferencesForm.types';
import { StyledSpecialistTimetablePreferencesForm } from './SpecialistTimetablePreferencesForm.styled';

type SpecialistTimetablePreferencesFormChildrenRenderProps = {
   handleSubmit: SpecialistTimetablePreferencesFormController['handleSubmit'];
};

type SpecialistTimetablePreferencesFormProps = {
   children: (renderProps: SpecialistTimetablePreferencesFormChildrenRenderProps) => ReactElement;
};

export const SpecialistTimetablePreferencesForm = (props: SpecialistTimetablePreferencesFormProps): ReactElement => {
   const [preferScheduleOnlyVisible] = useScheduleOnlyVisibilityPreferenceState();
   const [preferWeekendsVisible] = useWeekendsVisibilityPreference();
   const { register, handleSubmit } = useFormController<SpecialistTimetablePreferencesFormBean>({
      preferScheduleOnlyVisible: preferScheduleOnlyVisible,
      preferWeekendsVisible: preferWeekendsVisible,
   });

   return (
      <StyledSpecialistTimetablePreferencesForm direction={'column'} gap={'12px'}>
         <WeekendsVisibilityPreferenceField register={register} />
         <ScheduleOnlyVisibilityPreferenceField register={register} />

         {props.children({ handleSubmit: handleSubmit })}
      </StyledSpecialistTimetablePreferencesForm>
   );
};
